module.exports = __webpack_public_path__ + "static/img/SFU教室_3.8273496.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/studentLanding/SFU/SFU教室_3.png
// module id = l+Ue
// module chunks = 0